<app-tables
  [tableHeader]="tableHeader"
  [footerText]="footerText"
  [url]="url"
  [columns]="columns"
  [filters]="filters"
  (onActionButtonClick)="actionButtonClick($event.actionType, $event.row)"  
  [columnWidths]="columnWidths"
  [type]="'referralList'"
></app-tables>



<!-- [data]="referralList"
[totalCount]="totalReferralListCount"
(filtersChange)="filterReferralList($event.filters, $event.sort)"
  (onPageChange)="onPageChange($event)"
  (onPageSizeChange)="onPageSizeChange($event)"
  [tableLoading]="referralListLoading"
  [totalPage]="totalPage"
  [pageSize]="pageSize"
  (handleGetReferralList)="getReferralList(1, pageSize, filters)" -->
